import { useState, useEffect } from 'react';

const cdnUrl = `${
  process.env.RAZZLE_MAGENTO_MEDIA_URL
}/catalog/product/200x200`;

const useProductImage = (storeId, sku = '', type = 'thumbnail') => {
  const [productImage, setProductImage] = useState(null);
  const [loading, setLoading] = useState(true);

  async function fetchData() {
    const response = await fetch(
      `${
        process.env.RAZZLE_MAGENTO_URL
      }/rest/${storeId}/V1/products/${sku}/media`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }
    );
    const json = await response.json();

    const images = json.length
      ? json.filter(
          item =>
            !item.disabled &&
            item.media_type === 'image' &&
            item.types.includes(type)
        )
      : [];

    const image = images.length ? images[0].file : null;

    setProductImage(image ? `${cdnUrl}${image}` : null);
    setLoading(false);
  }

  useEffect(
    () => {
      fetchData();
    },
    [sku, type]
  );

  return { loading, productImage };
};

export default useProductImage;
